<template>
  <div class="indexPanel2">
    <Banner />
    <RecommendClass />
    <GoldTeacher />
  </div>
</template>

<script>
import Banner from "./Banner";
import RecommendClass from "./RecommendClass";
import GoldTeacher from "./GoldTeacher";
export default {
  components: {
    Banner,
    RecommendClass,
    GoldTeacher
  },
};
</script>

<style scoped>
.indexPanel2 {
  width: 100%;
  background-color: #fff;
  position: relative;
  overflow: hidden;
}
.indexPanel2:after {
  content: "";
  position: absolute;
  z-index: 1;
  background: url(../../assets/index_yuan.png);
  background-size: 100% 100%;
  width: 1103px;
  height: 2053px;
  right: 0;
  bottom: -300px;
}
</style>